import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import axios from "axios";

let env = process.env.REACT_APP_B2B_API_BASE_URL

const requestInstance = axios.create({
    baseURL: env,
    'Content-Type': 'application/json',
  });

//Login Service
export const accountDeletionApi = async(user) => {
  const data = user || {};
  const res = await requestInstance.post(`${env}${API_ENDPOINT.userDeletion.api}`, data)
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}